import React from "react";
import { Form, Select, Input, Tooltip } from "antd";
import { isEmpty, find, get } from 'lodash';

const Option = Select.Option;

const displayValue = (value, items, idField, nameField) => {
  if (value > -1) {

    return find(items, [idField, value])[nameField];
  } else {
    return ' ';
  }
};

const SelectInput = ({
  values,
  errors,
  handleSubmit,
  setFieldValue,
  setFieldTouched,
  name,
  label,
  formItemLayout,
  placeholder,
  readOnly,
  idField,
  nameField,
  nameFields,
  keyField,
  items,
  allowClear,
  onSelectionChanged,
  size,
  popupMatchSelectWidth,
  tooltip,
  autoFocus
}) => (
  <Form.Item label={tooltip ? <Tooltip placement='right' title={tooltip}>{label}</Tooltip> : label} {...formItemLayout}
    hasFeedback={!!get(errors, name)}
    validateStatus={get(errors, name) && "error"}
    help={get(errors, name)}
  >
    {!readOnly &&
      <Select
        popupMatchSelectWidth={popupMatchSelectWidth}
        size={size}
        allowClear={allowClear}
        showSearch
        autoFocus={autoFocus ? autoFocus : false}
        optionFilterProp="children"
        filterOption={true}
        placeholder={placeholder}
        value={get(values, name)}
        onChange={value => {
          setFieldValue(name, value);
          if (onSelectionChanged) {
            onSelectionChanged(value)
          }
        }}
        onBlur={() => setFieldTouched(name)}
        notFoundContent={placeholder}
      >
        {
          items.map(o => <Option key={keyField ? o[keyField] : o[idField]} value={o[idField]}>{nameFields ? nameFields.map(i => o[i]).join(' - ') : nameField ? o[nameField] : o.name}</Option>)
        }
      </Select>
    }
    {readOnly &&
      <Input
        placeholder={placeholder}
        value={displayValue(get(values, name), items, idField, nameField)}
        readOnly={readOnly}
      />
    }
  </Form.Item>
);

export default SelectInput;
